import React from 'react';
import cx from 'classnames';

import type {StatIndicatorVariant} from '../../../types/variants';

import styles from './StatIndicator.module.scss';

export const StatIndicator: React.FC<
    React.ComponentProps<'div'> & {
        color?: string;
        size?: 'small' | 'large';
        type?: 'circle' | 'arrowUp' | 'arrowDown';
        variant?: StatIndicatorVariant;
    }
> = ({
    className,
    color,
    role,
    size = 'small',
    type = 'circle',
    variant,
    ...divProps
}) => {
    const isArrow = type.includes('arrow');
    const customColorStyle = {
        circle: {
            backgroundColor: color,
            boxShadow: `0px 0px 10px ${color}`,
        },
        arrow: {
            borderColor: `transparent transparent ${color} transparent`,
        },
    };

    return (
        <div className={cx(styles.wrap, className)} role={role} {...divProps}>
            <div
                className={cx(
                    styles.indicator,
                    styles[size],
                    variant && styles[variant],
                    {
                        [styles.arrow]: isArrow,
                        [styles.down]: type === 'arrowDown',
                    },
                )}
                style={
                    color ? customColorStyle[isArrow ? 'arrow' : 'circle'] : {}
                }
                data-testid={`indicator-${type}`}
            />
        </div>
    );
};
